import { FunctionComponent, memo } from "react";
import { orderDates } from "../anomaly-metric-values-chart.utilities";
import { TimePeriodGroupBy } from "@edgetier/watchtower-types";
import { DateRangeDisplay } from "@edgetier/date-filter";
import { IProps } from "./metric-values-chart-date-range.types";
import "./metric-values-chart-date-range.scss";

/**
 * Display the date range that has been selected by the user.
 * @param props.firstDate
 * @param props.secondDate
 * @param props.timePeriodGroup
 * @returns A date range display that shows the date and time.
 */
const MetricValuesChartDateRange: FunctionComponent<IProps> = ({ firstDate, secondDate, timePeriodGroup }) => {
    const [leftDate, rightDate] = orderDates(firstDate, secondDate);
    const dateFormat =
        typeof timePeriodGroup !== "undefined" && timePeriodGroup === TimePeriodGroupBy.Minutes
            ? "d MMM HH:mm:ss"
            : "d MMM HH:mm";
    return <DateRangeDisplay format={dateFormat} startDate={leftDate} endDate={rightDate} />;
};

export default memo(MetricValuesChartDateRange);
